import * as Bixby from '$/core';

export abstract class ComplianceService {
  private static baseUrl = Bixby.Constants.API_COMPLIANCECONTROLLER;
  private static adminBaseUrl = `${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_COMPLIANCECONTROLLER}`;

  //approve
  public static async approveDeclarationByAdmin(
    clientId: string,
    companyId: string,
    declarationReason: string | undefined
  ) {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_APPROVE}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.adminBaseUrl}/${action}`);
    const model = { company_Id: companyId, client_Id: clientId, declarationReason };
    await Bixby.API.post(route, model);
  }

  public static async approveDeclarationByClient(companyId: string, declarationReason?: string) {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_APPROVE}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.baseUrl}/${action}`);
    const model = { company_Id: companyId, declarationReason };
    await Bixby.API.post(route, model);
  }

  public static async approveUserDeclarationByClient(companyId: string, userDeclarationId: string) {
    const action = `${Bixby.Constants.API_ACTION_USER_DECLARATIONS}/${Bixby.Constants.API_ACTION_APPROVE}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.baseUrl}/${action}`);
    const model = { companyId: companyId, userDeclarationId: userDeclarationId };
    await Bixby.API.post(route, model);
  }

  //create private company
  public static async createPrivateCompany(companyId: string) {
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.adminBaseUrl}/${companyId}`);
    await Bixby.API.post(route, null);
  }

  //reject
  public static async rejectDeclarationByAdmin(
    clientId: string,
    companyId: string,
    declarationReason: string | undefined
  ) {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_REJECT}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.adminBaseUrl}/${action}`);
    const model = { company_Id: companyId, client_Id: clientId, declarationReason };
    await Bixby.API.post(route, model);
  }

  public static async rejectDeclarationByClient(companyId: string, declarationReason?: string) {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_REJECT}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.baseUrl}/${action}`);
    const model = { company_Id: companyId, declarationReason };
    await Bixby.API.post(route, model);
  }

  public static async rejectUserDeclarationByClient(companyId: string, userDeclarationId?: string) {
    const action = `${Bixby.Constants.API_ACTION_USER_DECLARATIONS}/${Bixby.Constants.API_ACTION_REJECT}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.baseUrl}/${action}`);
    const model = { companyId: companyId, userDeclarationId: userDeclarationId };
    await Bixby.API.post(route, model);
  }

  //request to go private
  public static async requestDeclaration(request: Bixby.Models.CreateDeclarationRequest) {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_REQUEST}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.baseUrl}/${action}`);
    await Bixby.API.post(route, request);
  }

  //get company declaration form for admin
  public static async getCompanyDeclarationFormForAdmin(
    clientId: string
  ): Promise<Bixby.Models.AdminCompanyDeclarationForm> {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_DECLARATION_FORM}/${clientId}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.adminBaseUrl}/${action}`);
    const result: Bixby.Models.AdminCompanyDeclarationForm = await Bixby.API.get(route);
    return result;
  }

  //save company declaration form
  public static async createCompanyDeclarationForm(
    companyDeclarationForm: Bixby.Models.CreateCompanyDeclarationFormRequest
  ): Promise<Bixby.Models.AdminCompanyDeclarationForm> {
    const action = `${Bixby.Constants.API_ACTION_DECLARATIONS}/${Bixby.Constants.API_ACTION_DECLARATION_FORM}`;
    const route = Bixby.API.ServerRoute.forAction(`${ComplianceService.adminBaseUrl}/${action}`);
    const result: Bixby.Models.AdminCompanyDeclarationForm = await Bixby.API.post(route, companyDeclarationForm);
    return result;
  }
}
